module.exports = __webpack_public_path__ + "/static/assets/31bc4953d6286b30920ef5a53878e875.jpg";